import React from "react";
import "../styles/LoginRequiredModal.css"; // ✅ 새로운 스타일 적용

const LoginRequiredModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="login-modal-overlay">
            <div className="login-modal-container">
                <h2 className="login-modal-title">로그인이 필요합니다</h2>
                <p className="login-modal-message">해당 메뉴를 사용하려면 로그인해야 합니다.</p>
                <div className="login-modal-buttons">
                    <button className="login-modal-confirm" onClick={onConfirm}>로그인</button>
                    <button className="login-modal-close" onClick={onClose}>취소</button>
                </div>
            </div>
        </div>
    );
};

export default LoginRequiredModal;
